module.exports = __webpack_public_path__ + "img/0Q3A7263_L_BlackMatted.357a77e8.jpg";